import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { usersAPI } from '../../services/api';
import { parseApiError } from '../../utils/errors';

export default function CreateUser() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    username: '', email: '', full_name: '', password: '', confirmPassword: '',
    role: 'employee', department: '', employee_id: '', phone: '',
  });
  const [errors, setErrors] = useState({});
  const [serverError, setServerError] = useState('');
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((prev) => ({ ...prev, [k]: e.target.value }));

  const validate = () => {
    const e = {};
    if (!form.username) e.username = 'Required';
    if (!form.email) e.email = 'Required';
    if (!form.full_name) e.full_name = 'Required';
    if (!form.password) e.password = 'Required';
    if (form.password !== form.confirmPassword) e.confirmPassword = 'Passwords do not match';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setServerError('');
    setLoading(true);
    try {
      const payload = {
        username: form.username,
        email: form.email,
        full_name: form.full_name,
        password: form.password,
        role: form.role,
        department: form.department || null,
        employee_id: form.employee_id || null,
        phone: form.phone || null,
      };
      await usersAPI.create(payload);
      navigate('/admin/users');
    } catch (err) {
      setServerError(parseApiError(err, 'Failed to create user'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <div className="page-header">
        <h2>Create New User</h2>
        <button className="btn btn-ghost" onClick={() => navigate(-1)}>← Back</button>
      </div>

      <div className="form-card">
        {serverError && <div className="alert alert-error">{serverError}</div>}
        <form onSubmit={handleSubmit} autoComplete="off">

          <h4 className="form-section-title">Account Details</h4>
          <div className="form-row">
            <div className="form-group">
              <label>Full Name *</label>
              <input type="text" value={form.full_name} onChange={set('full_name')} placeholder="John Doe" required />
              {errors.full_name && <span className="field-error">{errors.full_name}</span>}
            </div>
            <div className="form-group">
              <label>Username *</label>
              <input type="text" value={form.username} onChange={set('username')} placeholder="johndoe" required />
              {errors.username && <span className="field-error">{errors.username}</span>}
              <small className="field-hint">3-50 chars, alphanumeric + underscore</small>
            </div>
          </div>

          <div className="form-group">
            <label>Email Address *</label>
            <input type="email" value={form.email} onChange={set('email')} placeholder="john@company.local" required />
            {errors.email && <span className="field-error">{errors.email}</span>}
          </div>

          <h4 className="form-section-title">Role &amp; Department</h4>
          <div className="form-row">
            <div className="form-group">
              <label>Role *</label>
              <select value={form.role} onChange={set('role')}>
                <option value="employee">Employee</option>
                <option value="hr">HR</option>
                <option value="super_admin">Super Admin</option>
              </select>
            </div>
            <div className="form-group">
              <label>Department</label>
              <input type="text" value={form.department} onChange={set('department')} placeholder="e.g. Engineering" />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Employee ID</label>
              <input type="text" value={form.employee_id} onChange={set('employee_id')} placeholder="EMP-001" />
            </div>
            <div className="form-group">
              <label>Phone</label>
              <input type="tel" value={form.phone} onChange={set('phone')} placeholder="+91 9876543210" />
            </div>
          </div>

          <h4 className="form-section-title">Password</h4>
          <div className="form-row">
            <div className="form-group">
              <label>Password *</label>
              <input type="password" value={form.password} onChange={set('password')} autoComplete="new-password" required />
              {errors.password && <span className="field-error">{errors.password}</span>}
              <small className="field-hint">Min 8 chars, uppercase, lowercase, number, special char</small>
            </div>
            <div className="form-group">
              <label>Confirm Password *</label>
              <input type="password" value={form.confirmPassword} onChange={set('confirmPassword')} autoComplete="new-password" required />
              {errors.confirmPassword && <span className="field-error">{errors.confirmPassword}</span>}
            </div>
          </div>

          <div className="form-actions">
            <button type="button" className="btn btn-ghost" onClick={() => navigate(-1)}>Cancel</button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Creating...' : 'Create User'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
